import { Button } from "@/components/ui/button";
import { X, Trash2 } from "lucide-react";

/**
 * Sticky bar shown when 1+ rows are selected on Clients/Tasks/Documents.
 * Presents primary actions inline plus a "clear selection" button.
 *
 * Props:
 *  - count: number
 *  - onClear: () => void
 *  - actions: [{ label, icon?, onClick, variant?, testid? }]
 */
export default function BulkActionBar({ count, onClear, actions = [] }) {
  if (!count) return null;
  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 rounded-full border border-border bg-card px-3 py-2 shadow-lg animate-in fade-in slide-in-from-bottom-3"
      data-testid="bulk-action-bar"
    >
      <div className="flex items-center gap-2 pl-2 pr-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium">
        <span data-testid="bulk-count">{count}</span> selected
      </div>
      {actions.map((a) => (
        <Button
          key={a.label}
          size="sm"
          variant={a.variant || "outline"}
          onClick={a.onClick}
          data-testid={a.testid || `bulk-${a.label.toLowerCase().replace(/\s+/g, "-")}`}
          className="h-8 gap-1.5"
        >
          {a.icon}
          {a.label}
        </Button>
      ))}
      <Button size="icon" variant="ghost" onClick={onClear} className="h-8 w-8" data-testid="bulk-clear">
        <X size={13} />
      </Button>
    </div>
  );
}

export { Trash2 };  // convenience re-export for callers
